import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Button} from '../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {CrmSyncSourcesEnum} from '../../../../models/api/crmSyncModel';

/*
 * Props.
 */

interface EditInCrmButtonProps {
  className?: string;
  source: string;
  linkUrl: string;
  navigateToLink: (arg: string) => void;
}

/*
 * Style.
 */

const StyledButtonContentDiv = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
`;

const StyledIcon = styled(Icon)`
  margin-left: 4px;
  margin-bottom: -2px;
`;

/*
 * Component.
 */

export const EditInCrmButton: FC<EditInCrmButtonProps> = (props) => {
  const {className, source, linkUrl, navigateToLink} = props;
  return (
    <Button className={className} variant={ButtonVariantsEnum.LINK} onClick={() => navigateToLink(linkUrl)}>
      <StyledButtonContentDiv>
        {renderEditInText(source)}
        <StyledIcon name="externalLinkSmall" />
      </StyledButtonContentDiv>
    </Button>
  );
};

/*
 * Helpers.
 */

function renderEditInText(source: string) {
  switch (source) {
    case CrmSyncSourcesEnum.SALESFORCE:
      return <Trans id="crm-sync-edit-in-salesforce">Edit in Salesforce</Trans>;
    case CrmSyncSourcesEnum.HUBSPOT:
      return <Trans id="crm-sync-edit-in-hubspot">Edit in Hubspot</Trans>;
    case CrmSyncSourcesEnum.MICROSOFT_DYNAMICS:
      return <Trans id="crm-sync-edit-in-dynamics-365">Edit in Dynamics 365</Trans>;
    case CrmSyncSourcesEnum.OUTLOOK_DIRECTORY:
      return <Trans id="crm-sync-view-in-outlook">View in Outlook directory</Trans>;
    default:
      return <Trans id="crm-sync-edit-in-crm">Edit in CRM</Trans>;
  }
}
